/*********** Footer Script START**************/

if ($(window).width() < 767){
 $('footer .footer-block__heading').each(function(){
    $(this).click(function(){
        $(this).siblings('.footer-block__details-content').slideToggle();
        $(this).toggleClass('active');
    })
 })
}

/*********** Footer Script END**************/

$().fancybox({
  selector : '[data-fancybox="images"]',
  buttons: [
    "slideShow",
    "thumbs",
    "zoom",
    "fullScreen",
    "close"
  ],
  loop: false,
  protect: true,
  mobile : {
      idleTime : false,
      margin   : 0,

      clickContent : function( current, event ) {
          return current.type === 'image' ? 'zoom' : false;
      },
      // clickSlide : function( current, event ) {
      //     return current.type === 'image' ? 'toggleControls' : 'close';
      // },
      clickSlide : 'close',
      dblclickContent : function( current, event ) {
          return current.type === 'image' ? 'zoom' : false;
      },
      dblclickSlide : function( current, event ) {
          return current.type === 'image' ? 'zoom' : false;
      }
  }
});      